import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints } from '../../constants';

export const Wrapper = styled(animated.div)`
    height: 175px;
    width: 100%;
    max-width: 280px;
    position: relative;
    margin: 0 auto;

    @media (${breakpoints.mediumMin}) {
        height: 150px;
        max-width: 250px;
    }

    @media (${breakpoints.largeMin}) {
        height: 175px;
        max-width: 280px;
    }
`;
